import { apiCaller, checkStatusResponse } from "../helpers";
import { setStateAdmin } from "./admins";

//Default State
const initialState = {
  listLanguage: [],
};

//Reducer
export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_STATE_LANGUAGE":
      return Object.assign({}, state, {
        [action.propertyName]: action.value,
      });
    case "SET_MULTIPLE_STATE_LANGUAGE":
      return Object.assign({}, state, action.newObject);
    default:
      return state;
  }
}
// set state language
export function setStateLanguage(propertyName, value) {
  return {
    type: "SET_STATE_LANGUAGE",
    propertyName,
    value,
  };
}

// set multi language
export function setMultipleStateLanguage(newObject) {
  return {
    type: "SET_MULTIPLE_STATE_LANGUAGE",
    newObject,
  };
}

export function getLanguage() {
  return async (dispatch) => {
    try {
      dispatch(setStateAdmin("loading", true));
      const res = await apiCaller("/api/language/getalllanguage", "GET", null);
      const { response } = res.data;
      //   console.log("res: ", response);
      dispatch(setStateAdmin("loading", false));
      dispatch(setStateLanguage("listLanguage", response));
    } catch (error) {
      console.log(error.response);
      dispatch(setStateAdmin("loading", true));

      checkStatusResponse(error.response);
    }
  };
}
